import {
  accountSearchColumns,
  customerSearchColumns,
  ngoaiTeSearchColumns,
  nhomColumns,
  QUERY_KEYS,
  regionSearchColumns,
  vatTuSearchColumns,
  warehouseSearchColumns
} from '@/constants';
import { Group, type KhachHang, KhoHang, KhuVuc, type NgoaiTe, type TaiKhoan, VatTu } from '@/types/schemas';
import { FormField, SearchField } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';

interface GeneralTabProps {
  searchState: {
    state: MuaHangRecord;
    actions: MuaHangRecord;
  };
}

const GeneralTab: React.FC<GeneralTabProps> = ({ searchState: { state, actions } }) => {
  return (
    <div className='h-80 w-[800px] min-w-[800px] space-y-4 p-4'>
      <div className='flex flex-col space-y-3'>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Mã kho</Label>
          <SearchField<KhoHang>
            searchEndpoint={`/${QUERY_KEYS.KHO_HANG}/`}
            searchColumns={warehouseSearchColumns}
            dialogTitle='Danh mục kho'
            columnDisplay={`ma_kho`}
            displayRelatedField={`ten_kho`}
            value={state.kho?.ma_kho || ''}
            relatedFieldValue={state.kho?.ten_kho || ''}
            onRowSelection={actions.setKho}
            className='w-fit'
          />
        </div>

        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Tài khoản có</Label>
          <SearchField<TaiKhoan>
            searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}/`}
            searchColumns={accountSearchColumns}
            dialogTitle='Danh mục tài khoản'
            columnDisplay={`code`}
            displayRelatedField={`name`}
            value={state.taiKhoanCo?.code || ''}
            relatedFieldValue={state.taiKhoanCo?.name || ''}
            onRowSelection={actions.setTaiKhoanCo}
            className='w-fit'
          />
        </div>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Tài khoản nợ</Label>
          <SearchField<TaiKhoan>
            searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}/`}
            searchColumns={accountSearchColumns}
            dialogTitle='Danh mục tài khoản'
            columnDisplay={`code`}
            displayRelatedField={`name`}
            value={state.taiKhoanNo?.code || ''}
            relatedFieldValue={state.taiKhoanNo?.name || ''}
            onRowSelection={actions.setTaiKhoanNo}
            className='w-fit'
          />
        </div>

        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Mã khách hàng</Label>
          <SearchField<KhachHang>
            type='text'
            searchEndpoint={`/${QUERY_KEYS.KHACH_HANG}/`}
            searchColumns={customerSearchColumns}
            dialogTitle='Danh mục khách hàng'
            columnDisplay={`customer_code`}
            displayRelatedField={`customer_name`}
            value={state.khachHang?.ma_kh || ''}
            relatedFieldValue={state.khachHang?.ten_kh || ''}
            onRowSelection={actions.setKhachHang}
            className='w-fit'
          />
        </div>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Ngoại tệ</Label>
          <SearchField<NgoaiTe>
            searchEndpoint={`/${QUERY_KEYS.NGOAI_TE}/`}
            searchColumns={ngoaiTeSearchColumns}
            dialogTitle='Danh mục ngoại tệ'
            columnDisplay={`ma_nt`}
            displayRelatedField={`ten_nt`}
            value={state.ngoaiTe?.ma_nt || ''}
            relatedFieldValue={state.ngoaiTe?.ten_nt || ''}
            onRowSelection={actions.setNgoaiTe}
            className='w-fit'
          />
        </div>

        {/* Mẫu báo cáo */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Mẫu báo cáo:</Label>
          <div className='w-64'>
            <FormField
              name='mau_bc'
              type='select'
              options={[
                { value: 10, label: 'Mẫu số lượng' },
                { value: 20, label: 'Mẫu số lượng và giá trị' },
                { value: 30, label: 'Mẫu số lượng và giá trị ngoại tệ' }
              ]}
              className='w-full'
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GeneralTab;
